import { requester } from "./api";

export const fetcher = (arg: string) => requester.get(arg).then((res: any) => res)